module.exports = __webpack_public_path__ + "img/DE02663.b5f60f8f.png";